// Stable Error-Codes — Quelle: lmm-wiki/datenmodelle/core.api.valitype.net/error-codes.md
// Frontend branched IMMER auf `code`, nie auf `message`.

export const ErrorCode = {
  // Validation
  ValidationError: 'validation_error',
  AcceptanceRequired: 'acceptance_required',

  // Auth / Tenant
  MissingToken: 'missing_token',
  InvalidToken: 'invalid_token',
  InvalidCredentials: 'invalid_credentials',
  TenantMismatch: 'tenant_mismatch',
  TenantNotInMembership: 'tenant_not_in_membership',
  MissingBrandOrigin: 'missing_brand_origin',
  UnknownTenant: 'unknown_tenant',
  MissingScope: 'missing_scope',
  Forbidden: 'forbidden',
  AccountNotActive: 'account_not_active',
  MfaRequired: 'mfa_required',
  MfaInvalidCode: 'mfa_invalid_code',

  // VAT
  InvalidVatId: 'invalid_vat_id',
  VatIdCountryMismatch: 'vat_id_country_mismatch',
  VatIdInvalid: 'vat_id_invalid',

  // Order / Billing
  UnknownProduct: 'unknown_product',
  InactiveProduct: 'inactive_product',
  OrderNotPending: 'order_not_pending',
  OrderNotFound: 'order_not_found',
  ConnectNotReady: 'connect_not_ready',
  StripeNotConfigured: 'stripe_not_configured',

  // SaaS
  UserNotFoundInTenant: 'user_not_found_in_tenant',
  SubscriptionNotFound: 'subscription_not_found',
  InvoiceNotFound: 'invoice_not_found',
  ServiceNotFound: 'service_not_found',

  // Settings
  UnknownSetting: 'unknown_setting',
  InvalidSettingValue: 'invalid_setting_value',
  NoFieldsToUpdate: 'no_fields_to_update',
  EmailExists: 'email_exists',

  // Misc
  TooManyRequests: 'too_many_requests',
  InternalError: 'internal_error',
  NotFound: 'not_found',
  Conflict: 'conflict',
};
